import { computed, ref } from 'vue'
import { useAuth } from '@clerk/vue'

/**
 * Dev bypass: when VITE_AUTH_MODE=dev, Clerk is skipped entirely — the plugin
 * is never installed and the API client sends no Authorization header. The
 * backend running with AUTH_MODE=dev accepts unauthenticated requests. This is
 * a build-time constant, so production builds (without the env var) use Clerk.
 */
export const isDevAuth = import.meta.env.VITE_AUTH_MODE === 'dev'

/**
 * Auth state for layouts/guards: Clerk's useAuth() in normal mode, or an
 * always-signed-in stub in dev mode (where useAuth would throw because the
 * Clerk plugin is not installed).
 */
export function useAuthState() {
  if (isDevAuth) {
    return {
      isLoaded: ref(true),
      isSignedIn: ref(true),
    }
  }
  const { isLoaded, isSignedIn } = useAuth()
  return {
    isLoaded,
    isSignedIn: computed(() => isSignedIn.value === true),
  }
}
